import { render, staticRenderFns } from "./SystemMovingAssistant.vue?vue&type=template&id=774178b0"
import script from "./SystemMovingAssistant.vue?vue&type=script&lang=js"
export * from "./SystemMovingAssistant.vue?vue&type=script&lang=js"
import style0 from "./SystemMovingAssistant.vue?vue&type=style&index=0&id=774178b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports